export enum ParcelStatus {
  EDITING = 'editing',
  WAITING_FOR_FINALIZATION = 'waitingForFinalization', //pending
  FINALIZED = 'finalized',
  NEED_YEARLY_DATA = 'needYearlyData',
  AWAITING_YIELD_DATA = 'awaitingYieldData',
  AWAITING_HISTORICAL_YIELD_DATA = 'awaitingHistoricalYieldData',
  AWAITING_PLANNED_CROP_DATA = 'awaitingPlannedCropData',
  AGRO_MAP_ORDERED = 'agroMapOrdered',
  AGRO_MAP_COMPLETED = 'agroMapCompleted'
}
